
// @ts-nocheck
import locale_de_45DE_46json_4f5663ba from "#nuxt-i18n/4f5663ba";
import locale_de_45DE_46json_addeec4a from "#nuxt-i18n/addeec4a";
import locale_de_45DE_46json_499dbc10 from "#nuxt-i18n/499dbc10";

export const localeCodes =  [
  "de-DE"
]

export const localeLoaders = {
  "de-DE": [
    {
      key: "locale_de_45DE_46json_4f5663ba",
      load: () => Promise.resolve(locale_de_45DE_46json_4f5663ba),
      cache: true
    },
    {
      key: "locale_de_45DE_46json_addeec4a",
      load: () => Promise.resolve(locale_de_45DE_46json_addeec4a),
      cache: true
    },
    {
      key: "locale_de_45DE_46json_499dbc10",
      load: () => Promise.resolve(locale_de_45DE_46json_499dbc10),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/32c9a052" /* webpackChunkName: "config_i18n_46config_46ts_32c9a052" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "de-DE",
      language: "de-DE",
      files: [
        {
          path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/i18n/locales/de-DE.json",
          cache: undefined
        },
        {
          path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/i18n/locales/de-DE.json",
          cache: undefined
        },
        {
          path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BB/i18n/locales/de-DE.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de-DE",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: true,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "de-DE",
    language: "de-DE",
    files: [
      {
        path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/node_modules/@interone/iff-frontend/i18n/locales/de-DE.json",
        cache: undefined
      },
      {
        path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/i18n/locales/de-DE.json",
        cache: undefined
      },
      {
        path: "/builds/egov/fms/gesundheitsberufe-iff/frontend/apps/BB/i18n/locales/de-DE.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/